import * as React from 'react';

const SvgLoading = ({
    width = 30,
    height = 30,
    color = '#341AE8',
    ...props
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{
                margin: 'auto',
                background: '0 0'
            }}
            width={width}
            height={height}
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid"
            display="block"
            {...props}
        >
            <circle
                cx={50}
                cy={50}
                fill="none"
                stroke={color}
                strokeWidth={10}
                r={30}
                strokeDasharray="141.37166941154067 49.12388980384689"
            >
                <animateTransform
                    attributeName="transform"
                    type="rotate"
                    repeatCount="indefinite"
                    dur="0.9900990099009901s"
                    values="0 50 50;360 50 50"
                    keyTimes="0;1"
                />
            </circle>
        </svg>
    );
};

export default SvgLoading;
